var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PdpTabBase',{attrs:{"headline":_vm.infoText.type,"data-preload":[_vm.$options.name],"is-expanded":_vm.activeTab}},[_c('div',{staticClass:"pdp-info-texts-tab__content",attrs:{"tabindex":"0"},domProps:{"innerHTML":_vm._s(_vm.infoText.value)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }